// src/controllers/athlete_social_post_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "post", "container", "addButton" ]

  connect() {
    // console.log("Hello, Stimulus!", this.element)
    // console.log(this.postTargets)
    // console.log(this.addButtonTarget)
    // console.log(this.containerTarget)
  }

  addSocialPost(event) {
    fetch('/social_posts').then(res => res.text()).then(partial => {
      this.containerTarget.insertAdjacentHTML( 'beforeend', partial );

      if (this.postTargets.length >= 4) {
       this.addButtonTarget.setAttribute('disabled', true);
      }
    });
  }
}

